/**
 * @prettier
 */
/* tslint:disable:max-classes-per-file */
/* ignore file coverage */

import React, { Component } from 'react';
import { BaseAlert, BaseAlertProps, BaseDefaultPropKeys, BaseDefaultProps } from './base';

type DefaultPropKeys =
  | 'textColor'
  | 'backgroundColor'
  | 'borderColor'
  | 'centerAlign'
  | 'renderAsBanner'
  | keyof BaseDefaultPropKeys;

type SuccessBannerProps = BaseAlertProps;

export class SuccessBanner extends Component<SuccessBannerProps> {
  static defaultProps: Pick<InformationBannerProps, DefaultPropKeys> = {
    ...BaseDefaultProps,
    textColor: 'white',
    backgroundColor: 'green500',
    centerAlign: true,
    renderAsBanner: true,
  };

  render() {
    const { children, ...props } = this.props;

    return <BaseAlert {...props}>{children}</BaseAlert>;
  }
}

type InformationBannerProps = BaseAlertProps;

export class InformationBanner extends Component<InformationBannerProps> {
  static defaultProps: Pick<InformationBannerProps, DefaultPropKeys> = {
    ...BaseDefaultProps,
    textColor: 'white',
    backgroundColor: 'blue1000',
    borderColor: undefined,
    centerAlign: true,
    renderAsBanner: true,
  };

  render() {
    const { children, ...props } = this.props;
    return <BaseAlert {...props}>{children}</BaseAlert>;
  }
}

type WarningBannerProps = BaseAlertProps;

export class WarningBanner extends Component<WarningBannerProps> {
  static defaultProps: Pick<WarningBannerProps, DefaultPropKeys> = {
    ...BaseDefaultProps,
    textColor: 'grey800',
    backgroundColor: 'amber700',
    borderColor: undefined,
    centerAlign: true,
    renderAsBanner: true,
  };

  render() {
    const { children, ...props } = this.props;
    return <BaseAlert {...props}>{children}</BaseAlert>;
  }
}

type DangerBannerProps = BaseAlertProps;

export class DangerBanner extends Component<DangerBannerProps> {
  static defaultProps: Pick<DangerBannerProps, DefaultPropKeys> = {
    ...BaseDefaultProps,
    textColor: 'white',
    backgroundColor: 'red600',
    borderColor: undefined,
    centerAlign: true,
    renderAsBanner: true,
  };

  render() {
    const { children, ...props } = this.props;
    return <BaseAlert {...props}>{children}</BaseAlert>;
  }
}
